import { useCallback } from 'react'

export interface UseSwapAnimationProps {
  executeMidpointFunction: () => void
}

export const useSwapAnimation = ({
  executeMidpointFunction,
}: UseSwapAnimationProps) => {
  const triggerSwapAnimation = useCallback(() => {
    // Просто выполняем swap функцию - меняем данные внутри полей
    executeMidpointFunction()
  }, [executeMidpointFunction])

  return {
    triggerSwapAnimation,
  }
}
